import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatStepper } from '@angular/material/stepper';

@Component({
  selector: 'app-confirm-driveplus-dialog',
  templateUrl: './confirm-driveplus-dialog.component.html',
  styleUrls: ['./confirm-driveplus-dialog.component.scss']
})

export class ConfirmDriveplusDialogComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<ConfirmDriveplusDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { 
      stepper: MatStepper, 
      toggleAddOn: Function, 
      addon: any,
      discountPercentage: string
    }
  ) { }

  ngOnInit(): void {}

  cancelDriveplus(): void {
    this.closeDialogAndNextStep();
  }

  triggerToggle(): void {
    const mockEvent = { source: null, checked: true };
    this.data.toggleAddOn(mockEvent, this.data.addon);
    this.closeDialogAndNextStep();
  }

  private closeDialogAndNextStep() {
    this.data.stepper.next();
    this.dialogRef.close();
    this.dialogRef.afterClosed().subscribe(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }
}
